/**
 * Camera 2D con inseguimento morbido (lerp) e clamp ai bordi della mappa.
 */

export class Camera {
  x = 0;
  y = 0;
  zoom = 2;

  constructor(
    public viewportW: number,
    public viewportH: number,
    public worldW: number,
    public worldH: number,
  ) {}

  /** Centra subito la camera sul punto (senza lerp). */
  snapTo(cx: number, cy: number): void {
    this.x = cx;
    this.y = cy;
    this.clamp();
  }

  follow(cx: number, cy: number, dt: number): void {
    const k = 1 - Math.exp(-8 * dt); // smorzamento esponenziale, frame-rate independent
    this.x += (cx - this.x) * k;
    this.y += (cy - this.y) * k;
    this.clamp();
  }

  private clamp(): void {
    const halfW = this.viewportW / 2 / this.zoom;
    const halfH = this.viewportH / 2 / this.zoom;
    if (this.worldW <= halfW * 2) {
      this.x = this.worldW / 2;
    } else {
      this.x = Math.min(Math.max(this.x, halfW), this.worldW - halfW);
    }
    if (this.worldH <= halfH * 2) {
      this.y = this.worldH / 2;
    } else {
      this.y = Math.min(Math.max(this.y, halfH), this.worldH - halfH);
    }
  }

  /** Trasformazione da applicare ai container in coordinate mondo. */
  transform(): { x: number; y: number; scale: number } {
    return {
      x: Math.round(this.viewportW / 2 - this.x * this.zoom),
      y: Math.round(this.viewportH / 2 - this.y * this.zoom),
      scale: this.zoom,
    };
  }

  resize(viewportW: number, viewportH: number): void {
    this.viewportW = viewportW;
    this.viewportH = viewportH;
    // su schermi piccoli riduci lo zoom per mantenere visibile abbastanza mappa
    this.zoom = viewportW < 700 ? 1.6 : 2;
    this.clamp();
  }
}
